import api from '../interceptors/axiosInterceptor'
import API_CONFIG from '../config'

const REVIEW_ENDPOINTS = {
  // نظرات محصولات
  PRODUCT_REVIEWS: '/reviews/products',
  PRODUCT_REVIEW: '/reviews/products', // /reviews/products/{reviewId}
  PRODUCT_REVIEW_BY_USER: '/reviews/products/user', // /reviews/products/user/{productId}
  
  // نظرات فروشگاه‌ها
  SHOP_REVIEWS: '/reviews/shops',
  SHOP_REVIEW: '/reviews/shops', // /reviews/shops/{reviewId}
  SHOP_REVIEW_BY_USER: '/reviews/shops/user', // /reviews/shops/user/{shopId}
  
  // امتیازات
  RATINGS: '/reviews/ratings',
  AVERAGE_RATING: '/reviews/ratings/average', // /reviews/ratings/average/{entityId}
  USER_RATING: '/reviews/ratings/user', // /reviews/ratings/user/{entityId}
  
  // پاسخ به نظرات
  REPLY: '/reviews/reply', // /reviews/reply/{reviewId}
  UPDATE_REPLY: '/reviews/reply', // /reviews/reply/{replyId}
  DELETE_REPLY: '/reviews/reply', // /reviews/reply/{replyId}
  
  // تایید/رد نظرات
  APPROVE: '/reviews/approve', // /reviews/approve/{reviewId}
  REJECT: '/reviews/reject', // /reviews/reject/{reviewId}
  
  // گزارش نظرات
  REPORT: '/reviews/report',
  REPORTED_REVIEWS: '/reviews/reported',
  
  // لایک/دیسلایک
  LIKE: '/reviews/like', // /reviews/like/{reviewId}
  DISLIKE: '/reviews/dislike', // /reviews/dislike/{reviewId}
  
  // آمار
  STATS: '/reviews/stats',
  RECENT_REVIEWS: '/reviews/recent'
}

const ReviewService = {
  // ========== نظرات محصولات ==========
  
  // دریافت نظرات یک محصول
  async getProductReviews(productId, params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.PRODUCT_REVIEWS}/${productId}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ارسال نظر برای محصول
  async createProductReview(productId, reviewData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.PRODUCT_REVIEWS}/${productId}`,
        reviewData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // بروزرسانی نظر محصول
  async updateProductReview(reviewId, reviewData) {
    try {
      const response = await api.put(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.PRODUCT_REVIEW}/${reviewId}`,
        reviewData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // حذف نظر محصول
  async deleteProductReview(reviewId) {
    try {
      const response = await api.delete(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.PRODUCT_REVIEW}/${reviewId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت نظر کاربر برای یک محصول
  async getUserProductReview(productId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.PRODUCT_REVIEW_BY_USER}/${productId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== نظرات فروشگاه‌ها ==========
  
  // دریافت نظرات یک فروشگاه
  async getShopReviews(shopId, params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.SHOP_REVIEWS}/${shopId}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ارسال نظر برای فروشگاه
  async createShopReview(shopId, reviewData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.SHOP_REVIEWS}/${shopId}`,
        reviewData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // بروزرسانی نظر فروشگاه
  async updateShopReview(reviewId, reviewData) {
    try {
      const response = await api.put(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.SHOP_REVIEW}/${reviewId}`,
        reviewData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // حذف نظر فروشگاه
  async deleteShopReview(reviewId) {
    try {
      const response = await api.delete(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.SHOP_REVIEW}/${reviewId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت نظر کاربر برای یک فروشگاه
  async getUserShopReview(shopId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.SHOP_REVIEW_BY_USER}/${shopId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== امتیازات ==========
  
  // ارسال امتیاز
  async submitRating(entityType, entityId, rating) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.RATINGS}`,
        { entityType, entityId, rating }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت میانگین امتیاز
  async getAverageRating(entityType, entityId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.AVERAGE_RATING}/${entityType}/${entityId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت امتیاز کاربر
  async getUserRating(entityType, entityId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.USER_RATING}/${entityType}/${entityId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== مدیریت پاسخ‌ها ==========
  
  // پاسخ به نظر
  async replyToReview(reviewId, replyText) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.REPLY}/${reviewId}`,
        { reply: replyText }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // بروزرسانی پاسخ
  async updateReply(replyId, replyText) {
    try {
      const response = await api.put(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.UPDATE_REPLY}/${replyId}`,
        { reply: replyText }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // حذف پاسخ
  async deleteReply(replyId) {
    try {
      const response = await api.delete(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.DELETE_REPLY}/${replyId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== مدیریت نظرات (ادمین) ==========
  
  // تایید نظر
  async approveReview(reviewId) {
    try {
      const response = await api.patch(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.APPROVE}/${reviewId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // رد نظر
  async rejectReview(reviewId, reason = '') {
    try {
      const response = await api.patch(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.REJECT}/${reviewId}`,
        { reason }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // گزارش نظر
  async reportReview(reviewId, reason) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.REPORT}`,
        { reviewId, reason }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت نظرات گزارش شده
  async getReportedReviews(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.REPORTED_REVIEWS}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== لایک/دیسلایک ==========
  
  async likeReview(reviewId) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.LIKE}/${reviewId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async dislikeReview(reviewId) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.DISLIKE}/${reviewId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== آمار و گزارشات ==========
  
  async getReviewStats(timeRange = 'month') {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.STATS}`,
        { params: { range: timeRange } }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  async getRecentReviews(limit = 10) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${REVIEW_ENDPOINTS.RECENT_REVIEWS}`,
        { params: { limit } }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ========== ابزارهای کمکی ==========
  
  // تولید ستاره‌های امتیاز
  generateStarRating(rating, maxStars = 5) {
    const stars = []
    const fullStars = Math.floor(rating)
    const hasHalfStar = rating % 1 >= 0.5
    
    for (let i = 1; i <= maxStars; i++) {
      if (i <= fullStars) {
        stars.push('full')
      } else if (i === fullStars + 1 && hasHalfStar) {
        stars.push('half')
      } else {
        stars.push('empty')
      }
    }
    
    return stars
  },

  // بررسی امکان ارسال نظر
  canSubmitReview(orderId, productId) {
    // این متد باید بررسی کند آیا کاربر سفارش این محصول را داده و می‌تواند نظر بدهد
    return api.get(`${API_CONFIG.BASE_URL}/orders/${orderId}/items/${productId}/review-eligibility`)
  },

  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data.message || 'خطا در مدیریت نظرات',
        status: error.response.status,
        data: error.response.data
      }
    }
    // ... مشابه قبلی
  }
}

export default ReviewService    